module.exports = __webpack_public_path__ + "img/temple_pin.8201e223.png";